export default function IconPatient() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="39" viewBox="0 0 40 39" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.759 25.8389C8.34734 25.8389 2.01733 26.9591 2.01733 31.4478C2.01733 35.9345 8.30685 37.0971 15.759 37.0971C23.1707 37.0971 29.5007 35.975 29.5007 31.4882C29.5007 27.0015 23.2112 25.8389 15.759 25.8389Z"
                stroke="#184353"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7589 19.4375C20.6486 19.4375 24.5666 15.5177 24.5666 10.6299C24.5666 5.7402 20.6486 1.82227 15.7589 1.82227C10.8712 1.82227 6.95129 5.7402 6.95129 10.6299C6.95129 15.5177 10.8712 19.4375 15.7589 19.4375Z"
                stroke="#184353"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M33.742 13.2344V20.9661"
                stroke="#FF5F39"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M37.6867 17.1008H29.8007"
                stroke="#FF5F39"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
}
